import { HttpService } from "./https.service";
import { BASE_URL } from "../../config/config";

const http = new HttpService();

export class LiveDashboardService {

  static async getLiveDashboardData(
    param1: any,
    range?: { from?: string; to?: string },
    refresh?: boolean,
  ): Promise<any> {
    try {
      // from/to drive ONLY the app-platform block; the signup and subscription
      // counts are lifetime totals and ignore them.
      const rangeQS = range?.from && range?.to
        ? `&from=${encodeURIComponent(range.from)}&to=${encodeURIComponent(range.to)}`
        : '';
      const path =
        BASE_URL +
        `/live-subscriber-count?sessionId=${param1}${rangeQS}${refresh ? '&refresh=1' : ''}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Live Dashboard Data :: ${error}`);
    }
  }
}
